import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import ControlPointDuplicateOutlinedIcon from "@mui/icons-material/ControlPointDuplicateOutlined";
import DeleteOutlineOutlinedIcon from "@mui/icons-material/DeleteOutlineOutlined";
import ManageAccountsIcon from "@mui/icons-material/ManageAccounts";
import ModeEditOutlinedIcon from "@mui/icons-material/ModeEditOutlined";
import SortableTree, {
  addNodeUnderParent,
  changeNodeAtPath,
  removeNodeAtPath,
  toggleExpandedForAll,
} from "@nosferatu500/react-sortable-tree";
import "@nosferatu500/react-sortable-tree/style.css";
import React, { useEffect, useState } from "react";
import FileExplorerTheme from "react-sortable-tree-theme-full-node-drag";

import SearchIcon from "@mui/icons-material/Search";
import {
  Box,
  Grid,
  IconButton,
  InputBase,
  Paper,
  Tooltip,
  Typography,
} from "@mui/material";
import { useMutation } from "react-query";
import { v4 as uuid } from "uuid";
import {
  EditOfficePost,
  GetOfficePosts,
} from "../../../services/officePosts.service";
import AddRoleModal from "./AddRoleModal";
import DelCategoryModal from "./DelCategoryModal";
import SetNewCategoryModal from "./SetNewCategoryModal";
import TreeSkeleton from "./TreeSkeleton";

const SortableTreeCmp = () => {
  const [treeData, setTreeData] = useState([
    {
      title: "چارت سازمانی",
      children: [],
      id: 0,
      parentOfficePostId: 0,
    },
  ]);

  const [openAddCategory, setOpenAddCategory] = useState(false);
  const [openDelCategory, setOpenDelCategory] = useState(false);
  const [openAddRole, setOpenAddRole] = useState(false);
  const [rowInfo, setRowInfo] = useState();
  const [childOrSibling, setChildOrSibling] = useState();
  const [isFirstTimeView, setFirstTimeView] = useState(true);
  const [searchQuery, setSearchQuery] = useState("");
  const [updateTree, setUpdateTree] = useState("");
  const [searchById, setSearchById] = useState(false);

  const addNodeCild = (event, title) => {
    let { path } = event;
    let newTree = addNodeUnderParent({
      treeData: treeData,
      parentKey: path[path.length - 1],
      expandParent: true,

      getNodeKey: ({ treeIndex }) => treeIndex,

      newNode: {
        title: title,
        expanded: true,
      },
    });
    setTreeData(newTree.treeData);
  };

  function addNodeSibling(event, title) {
    let { path } = event;

    let newTree = addNodeUnderParent({
      treeData: treeData,
      parentKey: path[path.length - 2],
      expandParent: true,
      getNodeKey: ({ treeIndex }) => treeIndex,
      newNode: {
        title: title,
      },
    });

    setTreeData(newTree.treeData);
  }

  function updateNode(event, title) {
    const { node, path } = event;
    const { children } = node;

    let newTree = changeNodeAtPath({
      treeData,
      path,
      getNodeKey: ({ treeIndex }) => treeIndex,
      newNode: {
        children,
        title: title,
      },
    });

    setTreeData(newTree);
  }

  const customSearchMethod = (node, searchQuery) => {
    let result;

    if (!isFirstTimeView) {
      if (searchById) {
        if (node.id.props) {
          result =
            searchQuery &&
            String(node.id.props.children[1])
              .toLowerCase()
              .indexOf(searchQuery) > -1;
        } else {
          result = searchQuery && String(node.id).indexOf(searchQuery) > -1;
        }
      } else {
        result = node.title.props
          ? searchQuery &&
            node.title.props.children[1]
              .toLowerCase()
              .indexOf(searchQuery.toLowerCase()) > -1
          : searchQuery &&
            node.title.toLowerCase().indexOf(searchQuery.toLowerCase()) > -1;
      }
    }

    return result;
  };

  function expand(expanded) {
    setTreeData(
      toggleExpandedForAll({
        treeData,
        expanded,
      })
    );
  }

  function expandAll() {
    expand(true);
  }

  function collapseAll() {
    expand(false);
  }

  const { mutate: GetOfficePostsMutate, isLoading } = useMutation(
    GetOfficePosts,
    {
      onSuccess: (data) => {
        if (data) {
          function getNestedChildren(arr, parent) {
            var children = [];
            for (var i = 0; i < arr.length; ++i) {
              if (arr[i].parentOfficePostId === parent.parentOfficePostId) {
                var grandChildren = getNestedChildren(
                  arr[i].subOfficePostResponses,
                  {
                    parentOfficePostId: arr[i].id,
                  }
                );

                if (grandChildren.length) {
                  arr[i].children = grandChildren;
                }
                arr[i].expanded = true;
                children.push(arr[i]);
              }
            }
            return children;
          }
          var nest = getNestedChildren(data, { parentOfficePostId: null });

          setTreeData(nest);

          if (data.length > 0) {
            setFirstTimeView(false);
          }
        }
      },
      onError: () => {},
    }
  );

  const { mutate: EditOfficePostMutate } = useMutation(EditOfficePost, {
    onSuccess: (data) => {
      if (data) {
        // DATA STORE IN STATE

        setUpdateTree(uuid());
      }
    },
    onError: () => {},
  });

  useEffect(() => {
    GetOfficePostsMutate({
      officePostId: null,
    });
    setTimeout(() => {
      setSearchQuery("");
    }, 1000);
  }, [updateTree]);

  const handleMoveNode = (rowInfo) => {
    EditOfficePostMutate({
      name: null,
      title: rowInfo.node.title,
      officePostId: rowInfo.node.id,
      parentOfficePostId:
        rowInfo.nextParentNode !== undefined ? rowInfo.nextParentNode.id : null,
    });
    setSearchById(true);
    setSearchQuery(rowInfo.node.id);
  };
  return (
    <>
      <Box
        sx={{
          // borderBottom: "2px solid #DAE0E4",
          marginBottom: "10px",
          // paddingBottom: "20px",
        }}
      >
        <Grid item width={"100%"} xs={12} maxWidth={"400px"}>
          <Paper
            elevation={0}
            style={{
              border: "1px solid #DAE0E4",
              display: "flex",
            }}
            square={false}
          >
            <InputBase
              sx={{ ml: 1, flex: 1, paddingX: "16px" }}
              placeholder="جستجو"
              onChange={(e) => {
                setSearchQuery(e.target.value);
                setSearchById(false);
              }}
              value={searchQuery}
            />

            <IconButton
              type="button"
              sx={{ color: "#9AAFC4" }}
              aria-label="search"
            >
              <SearchIcon />
            </IconButton>
          </Paper>
        </Grid>
      </Box>
      <div style={{ paddingRight: "2rem", display: "flex" }}>
        <Typography
          // className="btnForm SuccessDefault"
          sx={{
            width: "fit-content",
            cursor: "pointer",
            color: "#1D4A87",
            marginLeft: "5px",
          }}
          onClick={() => expandAll()}
        >
          باز کردن همه
        </Typography>
        |
        <Typography
          // className="btnForm SuccessDefault"
          sx={{
            width: "fit-content",
            cursor: "pointer",
            color: "#1D4A87",
            marginRight: "5px",
          }}
          onClick={() => collapseAll()}
        >
          بستن همه
        </Typography>
      </div>
      {!isLoading ? (
        <div
          style={{ height: "85vh", marginTop: "15px", direction: "rtl" }}
          className={!searchById ? "chartTree" : "chartTree-id"}
        >
          <SortableTree
            placeholderRenderer={() => {
              setTreeData([
                {
                  title: "چارت سازمانی",
                },
              ]);

              setFirstTimeView(true);
            }}
            theme={FileExplorerTheme}
            canDrag={() => true}
            treeData={treeData}
            onChange={(treeData) => setTreeData(treeData)}
            rowDirection="rtl"
            searchQuery={searchQuery}
            searchFocusOffset={0}
            searchMethod={({ node, searchQuery }) =>
              customSearchMethod(node, searchQuery)
            }
            onMoveNode={(rowInfo) => handleMoveNode(rowInfo)}
            generateNodeProps={(rowInfo) => ({
              onClick: () => {},
              buttons: [
                <>
                  <div className="sortable-tree-container">
                    <Tooltip arrow title="افزودن گروه">
                      <button
                        className="sortable-tree-btn"
                        onClick={(event) => {
                          setRowInfo(rowInfo);
                          setOpenAddCategory(true);
                          isFirstTimeView
                            ? setChildOrSibling("firstTime")
                            : setChildOrSibling("sibling");
                        }}
                      >
                        <AddCircleOutlineIcon />
                      </button>
                    </Tooltip>
                    <Tooltip arrow title="افزودن زیر گروه">
                      <button
                        className="sortable-tree-btn"
                        onClick={() => {
                          setRowInfo(rowInfo);
                          setOpenAddCategory(true);
                          setChildOrSibling("child");
                        }}
                        disabled={isFirstTimeView}
                      >
                        <ControlPointDuplicateOutlinedIcon />
                      </button>
                    </Tooltip>
                    <Tooltip arrow title="افزودن نقش سازمانی">
                      <button
                        className="sortable-tree-btn"
                        onClick={() => {
                          setRowInfo(rowInfo);
                          setOpenAddRole(true);
                        }}
                        disabled={isFirstTimeView}
                      >
                        <ManageAccountsIcon />
                      </button>
                    </Tooltip>
                    <Tooltip arrow title="ویرایش">
                      <button
                        className="sortable-tree-btn"
                        onClick={() => {
                          setRowInfo(rowInfo);
                          setOpenAddCategory(true);
                          setChildOrSibling("update");
                        }}
                        disabled={isFirstTimeView}
                      >
                        <ModeEditOutlinedIcon />
                      </button>
                    </Tooltip>

                    {rowInfo.node.children === undefined && (
                      <Tooltip arrow title="حذف کردن">
                        <button
                          className="sortable-tree-btn-del"
                          onClick={() => {
                            setOpenDelCategory(true);
                            setRowInfo(rowInfo);
                          }}
                          disabled={isFirstTimeView}
                        >
                          <DeleteOutlineOutlinedIcon />
                        </button>
                      </Tooltip>
                    )}
                  </div>
                </>,
              ],
              style: {
                height: "40px",
              },
            })}
          />
        </div>
      ) : (
        <TreeSkeleton />
      )}
      <SetNewCategoryModal
        openAddCategory={openAddCategory}
        setOpenAddCategory={setOpenAddCategory}
        addNodeCild={addNodeCild}
        addNodeSibling={addNodeSibling}
        updateNode={updateNode}
        rowInfo={rowInfo}
        childOrSibling={childOrSibling}
        setFirstTimeView={setFirstTimeView}
        setUpdateTree={setUpdateTree}
        setSearchQuery={setSearchQuery}
        setSearchById={setSearchById}
      />
      <DelCategoryModal
        openDelCategory={openDelCategory}
        setOpenDelCategory={setOpenDelCategory}
        rowInfo={rowInfo}
        setUpdateTree={setUpdateTree}
      />
      <AddRoleModal
        addRoleModal={openAddRole}
        setAddRoleModal={setOpenAddRole}
        rowInfo={rowInfo}
      />
    </>
  );
};

export default SortableTreeCmp;
